export default "__VITE_ASSET__Cydtw7fi__"